export default {
  controls: [
    {
      title: 'controls.folding_of_foot_siderails',
      icon: 'icon-foot-siderails-essenza',
      animation: 'folding_of_foot_siderails',
      autoHideLabel: true,
      checkTransferMode: true,
      toggle: true
    },
    {
      title: 'controls.folding_of_head_siderails',
      icon: 'icon-head-siderails-essenza',
      animation: 'folding_of_head_siderails',
      autoHideLabel: true,
      toggle: true
    },
    {
      title: 'controls.mobilift',
      icon: 'icon-mobilift',
      animation: 'mobilift',
      autoHideLabel: true,
      toggle: true
    }
  ],
  solutions: [
    {
      title: 'solutions.safety_and_ergonomics',
      style: 'thumbnails',
      image: 'superior-safety-and-ergonomics.jpg',
      explanation: 'safety_and_ergonomics'
    },
    {
      title: 'solutions.single_platform',
      style: 'thumbnails',
      image: 'efficiency-of-a-single-platform.jpg',
      explanation: 'single_platform'
    },
    {
      title: 'solutions.advanced_technologies',
      style: 'thumbnails',
      image: 'unparalleled-effectiveness.jpg',
      explanation: 'advanced_technologies'
    }
  ],
  keyFeatures: [
    {
      title: 'key_features.mobilization',
      style: 'thumbnails',
      image: 'safety.jpg',
      explanation: 'mobilization',
    },
    {
      title: 'key_features.transportation',
      style: 'thumbnails',
      image: 'transportation.jpg',
      explanation: 'transportation',
    },
    {
      title: 'key_features.additional_controls',
      style: 'thumbnails',
      image: 'additional_controls.jpg',
      explanation: 'additional_controls',
    },
    {
      title: 'key_features.comfort',
      style: 'thumbnails',
      image: 'ergoframe.jpg',
      explanation: 'comfort',
    }
  ],
  modifications: [
    {
      title: 'modifications.texture',
      icon: 'icon-colors',
      options: {
        style: 'vertical',
        default: 0,
        items: [
          {
            title: 'modifications.texture.none',
            image: 'no-texture.png',
            modelParts: [
              {
                name: 'postranice_zada_geoShape_1',
                texture: null
              }
            ]
          },
          {
            title: 'modifications.texture.ess_meteorites',
            image: 'meteorits.png',
            modelParts: [
              {
                name: 'postranice_zada_geoShape_1',
                texture: 'essenza_meteorit.png'
              }
            ]
          },
          {
            title: 'modifications.texture.ess_blue',
            image: 'blue.png',
            modelParts: [
              {
                name: 'postranice_zada_geoShape_1',
                texture: 'essenza_blue.png'
              }
            ]
          },
          {
            title: 'modifications.texture.ess_red',
            image: 'red.png',
            modelParts: [
              {
                name: 'postranice_zada_geoShape_1',
                texture: 'essenza_ny.png'
              }
            ]
          }
        ]
      }
    },
    {
      title: 'modifications.mattress',
      icon: 'icon-mattress',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.mattress.with_mattress',
            image: 'modifications--with_mattras.jpg',
            modelParts: [
              {
                name: 'matrace_geoPIV',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.mattress.without_mattress',
            image: 'modifications--without_mattras.jpg',
            modelParts: [
              {
                name: 'matrace_geoPIV',
                visible: false
              }
            ]
          }
        ]
      }
    },
    {
      title: 'modifications.siderails',
      icon: 'icon--siderails-standard-essenza',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.siderails-standard',
            image: 'modifications--standard-siderails.jpg',
            modelParts: [
              { name: 'alu_postranice', visible: false },
              { name: 'alu_postranice_zada', visible: false },
              { name: 'cover_geo', visible: true },
              { name: 'hlavaPostranice_geo', visible: true },
              { name: 'label_geo', visible: true },
              { name: 'nohy_posun_loc', visible: true },
              { name: 'lozna_plocha_geo', visible: true },
              { name: 'loznaa_plocha_geo', visible: true },
              { name: 'postranice_nohy_l01_loc', visible: true },
              { name: 'postranice_nohy_r01_loc', visible: true },
              { name: 'postranice_nohy_l02_loc', visible: true },
              { name: 'postranice_nohy_r02_loc', visible: true },
              { name: 'postranice_zada_l01_loc', visible: true },
              { name: 'postranice_zada_r01_loc', visible: true },
              { name: 'postranice_zada_l02_loc', visible: true },
              { name: 'postranice_zada_r02_loc', visible: true },

              { name: 'matrace_geoPIV', texture: 'matrace_clr.jpg' }
            ]
          },
          {
            title: 'modifications.siderails-alu',
            image: 'modifications--tele-siderails.jpg',
            modelParts: [
              { name: 'alu_postranice', visible: true },
              { name: 'alu_postranice_zada', visible: true },
              { name: 'cover_geo', visible: false },
              { name: 'hlavaPostranice_geo', visible: false },
              { name: 'label_geo', visible: false },
              { name: 'nohy_posun_loc', visible: false },
              { name: 'lozna_plocha_geo', visible: false },
              { name: 'loznaa_plocha_geo', visible: false },
              { name: 'postranice_nohy_l01_loc', visible: false },
              { name: 'postranice_nohy_r01_loc', visible: false },
              { name: 'postranice_nohy_l02_loc', visible: false },
              { name: 'postranice_nohy_r02_loc', visible: false },
              { name: 'postranice_zada_l01_loc', visible: false },
              { name: 'postranice_zada_r01_loc', visible: false },
              { name: 'postranice_zada_l02_loc', visible: false },
              { name: 'postranice_zada_r02_loc', visible: false },

              { name: 'matrace_geoPIV', texture: 'matrace_pasivni.jpg' }
            ]
          }
        ]
      }
    }
  ]
}